import { CapitalizedUnionMap, UnionMap } from '../../../types/union-map';

export interface RestoreFormData {
    restoreSnapshotId?: string;
}

export type RestoreFormFieldName = 'restoreSnapshotId';

export const RestoreFormFieldName: CapitalizedUnionMap<RestoreFormFieldName> = {
    RestoreSnapshotId: 'restoreSnapshotId',
};

export type SnapshotType = 'Manual' | 'Automatic';

export const SnapshotType: UnionMap<SnapshotType> = {
    Manual: 'Manual',
    Automatic: 'Automatic',
};

export interface RestoreSnapshotDropdownOption {
    createdTime: Date;
    locale: string;
    snapshotId: string;
    snapshotType: SnapshotType;
}
